"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidNote = void 0;
var React = require("react");
var moment = require("moment");
var recompose_1 = require("recompose");
var components_1 = require("components");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var sok_ui_1 = require("@caddigital/sok-ui");
var enhanceNote = (0, recompose_1.compose)((0, recompose_1.withState)('mode', 'setMode', 0), (0, recompose_1.withState)('note', 'setNote', ''), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        // mode: 0 closed, 1 open
        if (this.props.mode && !prevProps.mode) {
            this.props.setNote(this.props.row.note);
        }
    }
}), recompose_1.pure);
exports.BidNote = enhanceNote(function (props) { return (React.createElement("div", { className: 'note-bid-row' },
    React.createElement("div", { className: 'note-bid-created' },
        moment(props.row.createdAt).format('L LT'),
        " (",
        userLens_1.getName.get(props.row.author),
        ")"),
    React.createElement("div", { className: 'note-bid-content' },
        React.createElement("div", null, props.mode ? (React.createElement(sok_ui_1.TextInput, { value: props.note, onChange: function (e) { return props.setNote(e.target.value); } })) : (props.row.note)),
        React.createElement("div", { className: 'note-bid-buttons' }, props.mode ? (React.createElement(React.Fragment, null,
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-undo', className: 'black', disabled: props.editNoteStatus === 'FETCHING', onClick: function () { return props.setMode(0); } }),
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', className: 'green', disabled: props.editNoteStatus === 'FETCHING', onClick: function () { return props.editNote(__assign(__assign({}, props.row), { note: props.note })); } }))) : (React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-pen', className: 'black', onClick: function () { return props.setMode(1); } })))))); });
